import { useEffect, useState } from "react";
import { ArrowLeft, Save } from "lucide-react";
import { Link, useParams } from "react-router-dom";
import DashboardLayout from "../../components/layouts/DashboardLayout";
import axios from "axios";
import { SERVER_URL } from "../../utils/config";
import { message } from "../../utils/toast";
import CampaignForm from "../../components/layouts/CampaignForm";
import { Button } from "../../components/ui/Button";
import { Spinner } from "../../components/ui/Spinner";

const CampaignDetailsPage = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    axios
      .get(`${SERVER_URL}/api/campaign?id=${id}`)
      .then(({ data }) => {
        setFormData(data);
      })
      .catch((error) => {
        message({ type: "error", content: error.message });
      });
  }, [id]);

  const updateCampaign = () => {
    setLoading(true);
    axios
      .put(`${SERVER_URL}/api/campaign/${id}`, formData)
      .then(({ data }) => {
        switch (data.message) {
          case "campagin_updated":
            message({
              type: "success",
              content: "Campagin updated successfully"
            });
            break;

          default:
            break;
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        message({ type: "error", content: error.message });
      });
  };

  return (
    <DashboardLayout>
      <div className="p-8">
        <div className="max-w-3xl mx-auto">
          <div className="mb-6 flex items-center justify-between max-md:block">
            <div className="flex items-center gap-4 max-md:block">
              <Link
                to="/campaigns-list"
                className="flex items-center gap-2 text-gray-600 hover:text-gray-900"
              >
                <ArrowLeft size={20} />
                <span>Back to Campaigns</span>
              </Link>
              <h1 className="text-2xl font-bold text-gray-900">
                Campaign Details
              </h1>
            </div>
            <Button
              className={
                "text-white h-10 bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors max-md:mt-4 max-md:flex max-md:justify-center max-md:w-full"
              }
              onClick={updateCampaign}
            >
              {loading ? (
                <Spinner />
              ) : (
                <>
                  <Save size={20} />
                  &nbsp;Save Changes
                </>
              )}
            </Button>
          </div>

          <CampaignForm
            parentFormData={formData}
            onChangeValues={(formData) => setFormData(formData)}
            type="campaign"
          />
        </div>
      </div>
    </DashboardLayout>
  );
};

export default CampaignDetailsPage;
